function directToAuth(isRedirect) {
    const AUTH_PATHS = ['/login', '/register']
    const isAuthHref = AUTH_PATHS.some(path => window.location.href.includes(path))
    const _isDirect = isRedirect ?? true

    if (!isAuthHref && _isDirect) {
        return window.location.href = `/auth/login`;
    }

    return
}

export {
    directToAuth
}
